import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('logServiceForm');

    return {
        CANCEL: t('cancel'),
        LOG_SERVICE: t('logService'),
        SAVE: t('save')
    };
};

export default useTranslation;
